"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _tooltipContent = _interopRequireDefault(require("./tooltip-content"));
var _useDeterminePosition2 = _interopRequireDefault(require("./use-determine-position"));
var _useFocusTargetIsOutsideContainer = _interopRequireDefault(require("../../utils/use-focus-target-is-outside-container"));
var _useKeyPress = _interopRequireDefault(require("../../utils/use-key-press"));
var _useManageFocus = _interopRequireDefault(require("./use-manage-focus"));
require("./tooltip.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable complexity */
/**
 * A styled container to bring attention to content. Tooltip is triggered by
 * the child element that the Tooltip component wraps.
 */
/* eslint-disable-next-line max-statements */
var Tooltip = function Tooltip(_ref) {
  var bodyText = _ref.bodyText,
    children = _ref.children,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? '' : _ref$closeButtonAriaL,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? 'h2' : _ref$headingLevel,
    headingText = _ref.headingText,
    _ref$iconPath = _ref.iconPath,
    iconPath = _ref$iconPath === void 0 ? '' : _ref$iconPath,
    _ref$onlyShowOnce = _ref.onlyShowOnce,
    onlyShowOnce = _ref$onlyShowOnce === void 0 ? false : _ref$onlyShowOnce,
    _ref$showInitially = _ref.showInitially,
    showInitially = _ref$showInitially === void 0 ? false : _ref$showInitially,
    _ref$tooltipClassName = _ref.tooltipClassName,
    tooltipClassName = _ref$tooltipClassName === void 0 ? '' : _ref$tooltipClassName,
    _ref$displayInline = _ref.displayInline,
    displayInline = _ref$displayInline === void 0 ? true : _ref$displayInline,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? '' : _ref$wrapperClassName;
  var _useState = (0, _react.useState)(showInitially),
    _useState2 = _slicedToArray(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasFocus = _useState4[0],
    setHasFocus = _useState4[1];
  var tooltipRef = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);
  var _useDeterminePosition = (0, _useDeterminePosition2["default"])({
      showTooltip: showTooltip,
      wrapperRef: wrapperRef
    }),
    isMobile = _useDeterminePosition.isMobile,
    isTooltipHidden = _useDeterminePosition.isTooltipHidden,
    leftOffset = _useDeterminePosition.leftOffset,
    rightOffset = _useDeterminePosition.rightOffset,
    childIsLarger = _useDeterminePosition.childIsLarger;
  var focusTargetIsOutsideContainer = (0, _useFocusTargetIsOutsideContainer["default"])(wrapperRef);
  if (focusTargetIsOutsideContainer && hasFocus) {
    setShowTooltip(false);
  }
  (0, _useManageFocus["default"])({
    hasFocus: hasFocus,
    isTooltipHidden: isTooltipHidden,
    tooltipRef: tooltipRef,
    setHasFocus: setHasFocus,
    showTooltip: showTooltip
  });
  var toggleTooltip = function toggleTooltip() {
    if (!showTooltip) {
      var _navigator$vibrate, _navigator;
      (_navigator$vibrate = (_navigator = navigator).vibrate) === null || _navigator$vibrate === void 0 || _navigator$vibrate.call(_navigator, 200);
    }
    setShowTooltip(!showTooltip);
  };
  var toggleTooltipOffOnly = function toggleTooltipOffOnly() {
    if (!showTooltip) {
      var _navigator$vibrate2, _navigator2;
      (_navigator$vibrate2 = (_navigator2 = navigator).vibrate) === null || _navigator$vibrate2 === void 0 || _navigator$vibrate2.call(_navigator2, 200);
    }
    setShowTooltip(false);
  };
  var escapeKeyPressed = (0, _useKeyPress["default"])({
    targetKeyValue: 'Escape'
  });
  if (escapeKeyPressed && showTooltip) {
    setShowTooltip(false);
  }
  var tooltipClassList = (0, _classnames["default"])('position-absolute sb-tooltip-wrapper sb-global-gutters', tooltipClassName, {
    hidden: isTooltipHidden,
    'absoluteCenter-x': !isMobile && !leftOffset && !rightOffset
  });
  var positioningStyle = childIsLarger || !displayInline ? '' : 'auto';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('position-relative', wrapperClassName, {
      'inline-block': displayInline
    }),
    onClick: onlyShowOnce ? toggleTooltipOffOnly : toggleTooltip,
    ref: wrapperRef
  }, children, showTooltip && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: tooltipClassList,
    "data-e2e": "tooltip",
    ref: tooltipRef,
    style: {
      left: "".concat(leftOffset ? leftOffset : positioningStyle),
      right: "".concat(rightOffset ? rightOffset : positioningStyle)
    }
  }, /*#__PURE__*/_react["default"].createElement(_tooltipContent["default"], {
    bodyText: bodyText,
    closeButtonAriaLabel: closeButtonAriaLabel,
    headingLevel: headingLevel,
    headingText: headingText,
    iconPath: iconPath
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absoluteCenter-x sb-tooltip__caret"
  })));
};
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   *  Text for the body copy of tooltip content
   */
  bodyText: _propTypes["default"].string,
  /**
   * The element(s) that will trigger the showing and hiding of the tooltip
   */
  children: _propTypes["default"].any,
  /**
   * aria-label applied to tooltip close button
   */
  closeButtonAriaLabel: _propTypes["default"].string,
  /**
   * The heading element to be rendered, if `headingText` is being used.
   * This defaults to `h2`
   */
  headingLevel: _propTypes["default"].oneOf(['h2', 'h3', 'h4', 'h5', 'h6']),
  /**
   *  Text for the heading copy of tooltip content
   */
  headingText: _propTypes["default"].string,
  /**
   * Any icon path imported from this library, or a custom path.
   * Defaults to sparkles icon path
   */
  iconPath: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * This class is applied to the main wrapper `div` of the tooltip
   */
  tooltipClassName: _propTypes["default"].string,
  /**
   * This class is applied to the `div` that surrounds the tooltip and children/trigger element
   */
  wrapperClassName: _propTypes["default"].string,
  /**
   * This determines whether or not the Tooltip can be opened and closed multiple times versus just once. Defaults to false
   */
  onlyShowOnce: _propTypes["default"].bool,
  /**
   * This determines if the Tooltip automatically shows/pops up or if it opens on click. Defaults to false
   */
  showInitially: _propTypes["default"].bool,
  /**
   * This is for deciding whether or not to have `inline-block` styling on the outer `div`. Defaults to true
   */
  displayInline: _propTypes["default"].bool
} : {};
Tooltip.displayName = 'Tooltip';
var _default = exports["default"] = Tooltip;